import { Leaf, Phone, Mail, MapPin, Instagram } from 'lucide-react';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer id="contact" data-testid="site-footer" className="bg-[#1f3d2b] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">

          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="/" className="inline-flex items-center gap-3 mb-5">
              <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
                <Leaf size={16} className="text-white" />
              </div>
              <div>
                <span className="block font-['Cormorant_Garamond'] text-2xl font-semibold leading-none">Healthy Life</span>
                <span className="block text-[9px] tracking-[0.28em] uppercase text-[#d97736] font-bold mt-0.5">Vitamins</span>
              </div>
            </a>
            <p className="text-white/65 text-sm leading-relaxed max-w-[240px]">
              Your premier destination for natural vitamins, potent herbs, and exceptional personal care in the heart of Montclair Village, Oakland.
            </p>
            <a
              href="https://www.instagram.com/healthy_life_vitamins_oakland/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-5 text-white/65 hover:text-white transition-colors group"
              data-testid="footer-instagram"
            >
              <Instagram size={17} />
              <span className="text-sm group-hover:underline">@healthy_life_vitamins_oakland</span>
            </a>
          </div>

          {/* Store Hours */}
          <div>
            <h3 className="font-['Cormorant_Garamond'] text-xl font-semibold mb-5">Store Hours</h3>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between items-center">
                <span className="text-white/70">Monday – Saturday</span>
                <span className="font-semibold text-white">10AM – 6PM</span>
              </div>
              <div className="h-px bg-white/10" />
              <div className="flex justify-between items-center">
                <span className="text-white/70">Sunday</span>
                <span className="font-semibold text-white">11AM – 5PM</span>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-['Cormorant_Garamond'] text-xl font-semibold mb-5">Contact Us</h3>
            <div className="space-y-3 text-sm">
              <a
                href="https://maps.google.com/?q=6130+Medau+Pl+Oakland+CA+94611"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-3 text-white/70 hover:text-white transition-colors"
                data-testid="footer-address"
              >
                <MapPin size={15} className="shrink-0 mt-0.5" />
                <span>6130 Medau Pl.<br />Oakland, CA 94611</span>
              </a>
              <a
                href="tel:5103380667"
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                data-testid="footer-phone"
              >
                <Phone size={15} />
                <span>(510) 338-0667</span>
              </a>
              <a
                href="mailto:info@montclairvitamins.com"
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail size={15} />
                <span>info@montclairvitamins.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-['Cormorant_Garamond'] text-xl font-semibold mb-5">Quick Links</h3>
            <div className="space-y-2 text-sm">
              {[
                { href: '/booking', label: 'Book a Wellness Session' },
                { href: '/kiosk', label: 'Supplement Advisor' },
                { href: '/wellness-suite', label: 'Wellness Suite' },
                { href: '/account', label: 'My Account' },
                { href: '/staff', label: 'Staff Login' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block text-white/65 hover:text-white transition-colors py-0.5"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3 text-white/35 text-xs">
          <p>© {year} Healthy Life Vitamins. All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-1">
            <a href="/privacy-policy" className="hover:text-white/70 transition-colors">Privacy Policy</a>
            <a href="/terms" className="hover:text-white/70 transition-colors">Terms of Service</a>
            <a href="/refund-policy" className="hover:text-white/70 transition-colors">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
